import { render, staticRenderFns } from "./OrderDetailv2.vue?vue&type=template&id=69d1e9cf&"
import script from "./OrderDetailv2.vue?vue&type=script&lang=js&"
export * from "./OrderDetailv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports